<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>资质名称</th>
			    <th>资质等级</th>
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">资质名称</div>
		        	{{item.name}}
		        </td>
		        <td>
		        	<div class="label">资质等级</div>
		        	<el-select v-if="item.level" v-model="item.level">
					    <el-option
					      v-for="(g,k) in zizhiOptions"
					      :key="g.value"
					      :label="g.text"
					      :value="g.value">
					    </el-option>
					</el-select>
		        </td>
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>资质名称</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.name" name="name" placeholder="请填写资质名称">
				</div>
			</div>
	        <div class="item cf">
	        	<div class="name fl"><span>*</span>资质等级</div>
	        	<div class="ovh text">
		          	<el-select v-model="popData.level" placeholder="请选择资质等级">
					    <el-option
					      v-for="(g,k) in zizhiOptions"
					      :key="g.value"
					      :label="g.text"
					      :value="g.value">
					    </el-option>
					</el-select>
				</div>
			</div>
	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { urlHead } from '@/utils/http'
import { 
  qualificationList,
  qualificationAdd,
  qualificationEdit,
  qualificationDelete,
  qualificationQueryById
} from "@/api/tableapi";

import { queryDictItemsByCode } from "@/api/person/person";

export default {
	name: 'tablequalification',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
			uploadFileUrl:urlHead+'user-api/common/upload',
		    headers: {
		       'X-Access-Token':window.sessionStorage.getItem('token'), //headers属性中添加token，这个属性是el-upload自带的用来设置上传请求头部
		    },
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	name:'',
		    	level:''
		    },
		    popShow:false,

		    zizhiOptions:[]
		}
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			qualificationList("").then(res=>{
              if (res.success) {
              	let list=res.result.records
                that.formList=list
                //获取资质字典
                that.getQualification()
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.popData={
		    	name:'',
		    	level:''
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	qualificationQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2
		          that.popData=res.result
		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    save(){
	    	let that=this

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.name==''||that.popData.name==null) {
		    	that.$message.error('请填写资质名称！');
		    	return false
		    }

		    if (that.popData.level==''||that.popData.level==null) {
		    	that.$message.error('请选择资质等级！');
		    	return false
		    }

		    //添加
		    if (that.addOrEdit==1) {
		    	qualificationAdd(that.popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	qualificationEdit(that.popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    },

	    //获取资质等级
	    getQualification(){
	    	let that=this
	    	queryDictItemsByCode('dictCode=qualificationGrade').then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.zizhiOptions = res.result
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tablequalification/index.vue